




















import ApiClient from '@/js/api.js'
import PopupTemplate from '@/views/templates/kuntama/PopupTemplate.vue'
import QuizKuntama from '@/views/organisms/QuizKuntama.vue'

export default
  components: {
    PopupTemplate
    QuizKuntama
  }

  data: () ->
    baseColor: '#E0B48E'
    point: 0
    mode: 0
    quizResult: 0
    quizData:
      hukidashi: [
        '“燻らのたまご”は、どこで製造されているでしょうか？'
      ]
      quiz: [
        '大阪府'
        '栃木県'
        '福島県'
      ]
      success_message: [
        '燻製たまごの本場、福島県の山里にある'
        '福虎で製造されているよ！'
      ]
      answer: 3

  methods: {
    closePopup: () ->
      m = @mode
      if m == 0
        m = 2
      @$emit('closePopup', m)
    success: () ->
      @mode = 3
      @quizResult = 2
      @baseColor = '#F699AB'
      api = new ApiClient()
      param =
        'point_code': 'p4-2'
      data = await api.post('/member/point/save', true, param)
      @point = data.point
      if @point > 0
        @$emit('addPoint', @point)
      @$emit('success')
    miss: () ->
      @baseColor = '#7BCAD8'
      @mode = 2
      @quizResult = 1
  }
